<template>
  <div
    :class="['link-card-item pa-6 clickable', type]"
    @click="$router.push({ path: project.link })"
  >
    <div class="d-flex">
      <div
        :class="[
          'tag text-7 font-weight-medium text-uppercase black--text-abs',
          tag.replaceAll(' ', '-'),
          { 'ml-2': index > 0 },
        ]"
        v-for="(tag, index) in tags"
        :key="tag"
      >
        {{ tag }}
      </div>
    </div>
    <div class="text-4 mt-3 font-weight-medium">{{ project.text }}</div>
    <div class="text-6 mt-2 line-height-50 gray--text description">
      {{
        project.description ||
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis enim natus debitis cupiditate ipsam rem asperiores quas, autem officiis ab. Veritatis eos facere cupiditate cum illum expedita repellendus at magnam!"
      }}
    </div>
    <div
      class="mt-3 text-4 font-weight-medium text-center"
      v-if="type !== 'blog'"
    >
      <span v-if="!project.variesApy">{{ apy | numberFormat("0,0.00", false) }}% APY</span>
      <span v-else>Varies</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    tags: Array,
    project: Object,
    apy: Number,
  },
};
</script>

<style lang="scss" scoped>
.link-card-item {
  height: 190px;
  border-radius: 16px;
  .tag {
    padding: 4px 8px;
    border-radius: 4px;
    white-space: nowrap;
    &.new,
    &.featured,
    &.latest {
      background: rgba(246, 96, 51, 0.1);
      color: #f66033 !important;
    }
    &.proof-of-stake {
      background: #e9ebff;
    }
    &.defi-vaults {
      background: #e3f9ed;
    }
    &.blog {
      background: #fbcdc0;
    }
  }
  &.stake {
    border: 1px solid #7387ff;
  }
  &.vault {
    border: 1px solid #49d999;
  }
  &.blog {
    border: 1px solid #f66033;
  }
  .description {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
  }
}
</style>
